<template>
  <section class="career-guidance-container">
    <div class="content-container container">
      <div v-if="isLoading" class="loading-container">
        <b-loading :is-full-page="false" :active="isLoading"></b-loading>
        <p class="loading-text">Loading your guidance...</p>
      </div>
      <div v-else>
        <h2 class="section-title">
          <span class="icon"><i class="mdi mdi-lightbulb-on-outline"></i></span>
          Personalized Career Guidance
        </h2>
        <b-tabs v-model="activeTab" type="is-boxed" expanded>
          <b-tab-item label="General Career Guidance">
            <div class="tab-panel-content">
              <h3 class="tab-panel-title">
                <i class="mdi mdi-account-star"></i>
                General Guidance
              </h3>
              <p class="guidance-text">
                {{ user.guidance.generalGuidance }}
              </p>
            </div>
          </b-tab-item>
          <b-tab-item label="Potential Career Paths">
            <div class="tab-panel-content">
              <template v-if="user.guidance.careerGuidance && user.guidance.careerGuidance.length">
                <div
                  v-for="(career) in user.guidance.careerGuidance"
                  :key="career.archetypeName"
                  class="career-path-panel"
                >
                  <h4 class="tab-panel-title">
                    <i class="mdi mdi-briefcase"></i>
                    {{ career.archetypeName }}
                  </h4>
                  <p class="guidance-text">{{ career.summary }}</p>
                </div>
              </template>
              <div v-else class="no-career-guidance">
                <i class="mdi mdi-alert-circle-outline"></i>
                No career-specific guidance available.
              </div>
            </div>
          </b-tab-item>
        </b-tabs>
      </div>
    </div>
  </section>
</template>

<script>
import { getUser } from '../../utils/helpers.js';
import { useUserStore } from '@/stores/userStore';

export default {
  name: 'CareerPathways',
  data() {
    return {
      user: null,
      isLoading: true,
      activeTab: 0,
      config: {
        headers: { 'Authorization': this.$cookies.get('teamwrkr-token') }
      }
    };
  },
  created() {
    this.userStore = useUserStore();
    this.user = this.userStore.user;
    if (this.user?._id && this.user.isStatsheetLocked === false) {
      this.$router.push(`/profile/${this.user._id}`)
    }
  },
  mounted() {
    if (this.user?._id) {
      this.isLoading = false;
    } else {
      this.fetchUserData();
    }
  },
  methods: {
    async fetchUserData() {
      this.isLoading = true;
      try {
        const token = this.$cookies.get('teamwrkr-token');
        const userData = await getUser(token);
        this.userStore.setUser(userData);
        this.user = userData;
      } catch (err) {
        console.error('Error fetching user data', err);
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.career-guidance-container {
  font-family: 'Nunito', sans-serif;
  background-color: $color-surface-cool;
  min-height: 100vh;
}

.container {
  max-width: 900px;
  margin: 0 auto;
  padding: 1.5rem 1rem;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;

  .loading-text {
    margin-top: 1.5rem;
    color: $color-text-subtle;
  }
}

.section-title {
  display: flex;
  align-items: center;
  color: $color-text;
  font-size: 1.4rem;
  font-weight: 700;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid $color-border-muted;

  .icon {
    margin-right: 12px;
    color: $color-primary;
    font-size: 1.7rem;
  }
}

.b-tabs {
  margin-bottom: 2rem;
}

.tab-panel-content {
  padding: 2rem;
  background: $color-surface;

  box-shadow: 0 2px 12px rgba(170, 118, 214, 0.07);
  margin-bottom: 2rem;
}

.tab-panel-title {
  font-size: 1.15rem;
  font-weight: 700;
  color: $color-primary;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.career-path-panel {
  margin-bottom: 2rem;
}

.career-path-title {
  font-size: 1.08rem;
  font-weight: 700;
  color: $color-text;
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  i {
    color: $color-warning;
    font-size: 1.2rem;
  }
}

:deep(.tab-content) {
  padding: 0 !important;
}

.guidance-text {
  margin: 0;
  white-space: pre-line;
  text-align: left;
}

.no-career-guidance {
  color: $color-accent;
  font-weight: 600;
  margin-top: 1.5rem;
  text-align: center;
  i {
    font-size: 1.5rem;
    margin-right: 0.5rem;
  }
}
</style>
